import { Component, EventEmitter, Output } from "@angular/core";
import { User } from "../../classes/flow/session/impl/User";
import { ApplicationService } from "../../services/application.service";
import { UserService } from "../../services/user.service";
import { ENVIRONMENT } from "../../../environments/environment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.less"],
})
export class HeaderComponent {
  @Output()
  public openMenu = new EventEmitter();
  public ENV = ENVIRONMENT;

  public constructor(public readonly applicationService: ApplicationService, public readonly userService: UserService) {}
  /**
   * Retrieves the active session
   * @returns
   */
  public getSessionActive(): User | undefined {
    return this.applicationService.session.user;
  }

  public async logout() {
    await this.userService.logout();
  }

  public customLogoURLRoleCheck(test: any) {
    return test.some((url: any) => url.roles.includes(this.applicationService.session.activeRole.name));
  }
}
